import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-tacms-error-report',
  templateUrl: './tacms-error-report.component.html',
  styleUrls: ['./tacms-error-report.component.scss']
})
export class TacmsErrorReportComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/tacms-error-report/tacms-error-report.component.ts